export default __webpack_public_path__ + "static/media/1.417b470c.png";